/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ItemMenuPath
 */
export interface ItemMenuPath {
    /**
     * 
     * @type {string}
     * @memberof ItemMenuPath
     */
    model: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ItemMenuPath
     */
    path: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ItemMenuPath
     */
    itemId: string;
    /**
     * 
     * @type {number}
     * @memberof ItemMenuPath
     */
    productId: number;
}

export function ItemMenuPathFromJSON(json: any): ItemMenuPath {
    return ItemMenuPathFromJSONTyped(json, false);
}

export function ItemMenuPathFromJSONTyped(json: any, ignoreDiscriminator: boolean): ItemMenuPath {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'model': json['model'],
        'path': json['path'],
        'itemId': json['itemId'],
        'productId': json['productId'],
    };
}

export function ItemMenuPathToJSON(value?: ItemMenuPath | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'model': value.model,
        'path': value.path,
        'itemId': value.itemId,
        'productId': value.productId,
    };
}


